// 個人支付模塊
export default {
    Mywallet: {
        MyAccount: '我的賬戶',
        AvailableBalance: '可用余額',
        RMB: '元',
        Withdrawal: '提現',
        ExpenditureAmount: '支出金額',
        TransactionRecords: '交易記錄',
        ApplyForInvoice: '申請發票',
        Withdrawing: '提現中',
        BalanceWithdrawalProcess: '處於提現流程的余額',
        InUse: '使用中',
        OccupationAmount: '用戶紅包、樣本收集等占用金額',
        FunctionTemporarilyOpen: '該功能暫為開放',
        AccountBalance: '賬戶余額',
        TransactionType: '交易類型',
        All: '全部',
        Other: '其他',
        TextMessage: '短信',
        Mail: '郵件',
        RedEnvelope: '紅包',
        Recharge: '充值',
        CapitalFlow: '資金流向',
        Income: '收入',
        Expenditure: '支出',
        Time: '時間',
        TransactionName: '交易名稱',
        PaymentMethod: '支付方式',
        SMSBalance: '短信余額',
        SMSSending: '短信發送',
        SMSVerification: '短信驗證',
        SMSGift: '短信贈送',
        SMSPurchase: '短信購買',
        UsageDetails: '使用明細',
        SMSChangesPiece: '短信變更(條)',
        SMSBalancePiece: '短信余額(條)',
        ChangeType: '變更類型',
        MailBalance: '郵件余額',
        EmailSending: '郵件發送',
        EmailGifts: '郵件贈送',
        EmailPurchase: '郵件購買',
        EmailReturn: '郵件退回',
        EmailChangesPiece: '郵件變更(條)',
        EmailBalancePiece: '郵件余額(條)',
        Sending: '發送',
        Give: '贈送',
        Purchase: '購買',
        TestVerify: '驗證',
        Return: '退回',
        Mailbox: '郵箱',
        AccountRecharge: '賬戶充值',
        RechargeAccount: '充值賬戶',
        RechargeAmount: '充值金額',
        RechargeLeast10: '最少充值10',
        Alipay: '支付寶',
        WeChat: '微信',
        BankTransfer: '銀行轉賬',
        Payment: '支付',
        ClickPayment: '點擊了支付'
    },
  };